import { css, styled } from 'styled-components';

import type { TCardMode } from '@/modules/game/types';

interface IScEmptyGameCardContainerProps {
  mode: TCardMode;
  withoutBottom?: boolean;
  isEveryEmpty?: boolean;
}

export const ScEmptyGameCardContainer = styled.div<IScEmptyGameCardContainerProps>`
  display: flex;
  width: 100%;
  min-width: 101px;
  height: ${({ withoutBottom }) =>
    withoutBottom ? '100%' : 'calc(100% - 36px)'};
  padding: 0px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  border-radius: 12px;

  ${({ withoutBottom }) =>
    withoutBottom &&
    css`
      aspect-ratio: 1;
    `}

  ${({ isEveryEmpty }) =>
    isEveryEmpty &&
    css`
      height: 100%;
      aspect-ratio: 1;
    `}

  &.black {
    background-color: ${({ theme }) => theme.blackColor};
  }

  &.dark {
    background-color: ${({ theme }) => theme.grayDarkColor};
  }

  &.light {
    background-color: ${({ theme }) => theme.gray1Color};
  }

  img {
    filter: ${({ mode }) =>
      `invert(${['dark', 'black'].includes(mode) ? 0 : 1})`};
  }
`;
